import * as z from 'zod';

// Types
import { TextZod } from '@/components/molecules/Text/TextType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';

const FramedPicturesZod = z.object({
  __component: z.literal('block.framed-pictures'),
  id: z.number(),
  text: TextZod.nullable(),
  waveWrapper: WaveWrapperZod.nullable(),
});

export { FramedPicturesZod };
export type FramedPicturesType = z.infer<typeof FramedPicturesZod>;
